/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MatchesFilter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function MatchesFilter({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Content/SyncPatients/Content/MatchesFilter",
  onChange
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let filtersTypeValueData = fromData.useDataValue({ viewPath,
context: 'filters',
path: 'type',
})
let filtersTypeChangeData = fromData.useDataChange({ viewPath,
context: 'filters',
path: 'type',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 maxWidth={100}
 marginTop={0}
 placeholder="All"
 data="options"
 from={optionsValueData}
 data="filters.type"
 value={filtersTypeValueData}
 onChange={filtersTypeChangeData}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}